import StorageFactory from '@mvps-genesis/storage-factory';

export default class RecommendationsService {

	constructor () {
		this.apiURL = window.mivaJS?.Japi_Url;
		this.recommendationURL = `https://${window?.mivaJS?.SS_SITE_ID}.a.searchspring.io/boost/${window?.mivaJS?.SS_SITE_ID}/recommend`;
	}

	getProductCodes () {
		const productCodeElems = document.getElementsByClassName('js-mini-basket-item');
		const productCodes = [];

		for (const productCodeElem of productCodeElems) {
			productCodes.push(productCodeElem.getAttribute('data-product-code'));
		}

		return productCodes;
	}

	async sendRequest (params) {
		const requestParams = new URLSearchParams(params).toString();
		const url = this.recommendationURL + '?' + requestParams;

		const response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'GET'
		});

		if (!response.ok) {
			return false;
		}

		const jsonResponse = await response.json();

		if (!jsonResponse || !jsonResponse[0].results || jsonResponse[0].results.length === 0) {
			return false;
		}

		return jsonResponse[0].results;
	}

	async getRecommendations (tags = 'no-results', list = 'Product Recommendations', limits = 20) {
		let params = {
			cart: this.getProductCodes(),
			limits: limits,
			list: list,
			tags: tags.split(',').map(function (tag) {
				return tag.trim();
			})
		};

		if (window.mivaJS.Page_Code === 'PROD' && window.mivaJS.Product_Code) {
			params.product = String(window.mivaJS.Product_Code);
		}

		if (window.mivaJS.Customer_ID !== 0 && window.mivaJS.Customer_ID) {
			params.shopper = Number(window.mivaJS.Customer_ID);
		}

		if (window.mivaJS.Category_Code) {
			params.categories = [String(window.mivaJS.Category_Code)];
		}

		const recentlyViewedProducts = StorageFactory.sessionGet('recentlyViewedProducts');

		if (recentlyViewedProducts) {
			params.lastViewed = recentlyViewedProducts;
		}

		const recommendations = await this.sendRequest(params);

		if (recommendations === false) {
			return false;
		}

		const recommendationsData = await this.recommendationsDataRequest(recommendations);

		if (recommendationsData === false) {
			return false;
		}

		return recommendationsData.products;
	};

	async recommendationsDataRequest (recommendations) {

		const apiSettings = {
			function: 'searchspring-recommendations'
		};

		const requestBody = {
			...apiSettings,
			...{recommendations}
		};

		const response = await fetch(this.apiURL, {
			body: JSON.stringify(requestBody),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});

		if (!response.ok) {
			return {};
		}

		const recommenationData = await response.json();

		if (recommenationData.success !== 1 || recommenationData.products_count === 0) {
			return {};
		}

		return recommenationData;
	}
}
